export const ONEDAY = 24 * 60 * 60 * 1000;

export function diffDays(firstDate: Date, secondDate: Date) {
  console.log(firstDate);
  return Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / ONEDAY));
}